export const LIGHT_MODE_COLORS = {
  /* default */
  background: "#FFFFFF",
  backgroundMain: "#e6eaeb",
  text: "#000000",
  border: "#E0E0E0",
  shadow: "#B0B0B0",

  lightBrown: "#6c6c72",
  lightGray: "#f1f1f1",
  gray: "#C5C5C5",
  white: "#FFFFFF",
  blue: "#007acc",
  hoverBlue: "#004d80",

  /* application */
  primary: "#5956E9",
  primaryLight: "#665FF4",
  primaryDark: "#423FD9",
  primaryDarker: "#2A28A0",
};

export const DARK_MODE_COLORS = {
  background: "#000000",
  backgroundMain: "#4d4d4d",
  text: "#FFFFFF",
  border: "#303030",
  shadow: "#1A1A1A",

  lightBrown: "#d1d1d3",
  lightGray: "#2b2b2b",
  white: "#000000",
  blue: "#e6f5ff",
  hoverBlue: "#b3e0ff",

  /* application */
  primary: "#282774",
  primaryLight: "#171544",
  primaryDark: "#0b0a3b",
  primaryDarker: "#9fabdd",
};
